import React from "react";
import { useIntl } from "react-intl";
import { History } from "history";
import { match } from "react-router-dom";
import routing from "../../../routing";

import SharePlay from "../../../pages/play-plan/play-plan";
import { OuterWrapper, InnerWrapper } from "./styles";
import data from "../data";

import { rhythmTask, pianoTask } from "../../../../common/sampleTasks";
import { IUser } from "../../../store/user/models";
import { ITask } from "../../../../common/types";

const VirtualSolveInClass = () => {
    const intl = useIntl();
    return (
        <OuterWrapper>
            <InnerWrapper>
                <SharePlay
                    isSimulation
                    match={{ params: { id: "" }, isExact: true, path: "", url: "" } as match<{id: string}>}
                    intl={intl}
                    history={{ location: { pathname: `/${routing.publicPlay}` } } as History}
                    plan={{
                        _id: "",
                        tasks: [rhythmTask, pianoTask] as ITask[],
                        description: { en: "" },
                        name: { en: "" },
                        scores: [],
                        user: "",
                        created: 1,
                        experience: {
                            enabled: false,
                            positions: [],
                        },
                        meta: {
                            teaching: {},
                            opus: {},
                            pitch: {},
                            rhythm: {},
                        },
                    }}
                    user={{ loggedIn: true } as IUser}
                    initialStudents={data.results}
                    initialResults={[[], []]}
                    resetPlan={() => null}
                    getPlan={() => null}
                    post={() => null}
                    taskCompleted={() => null}
                />
            </InnerWrapper>
        </OuterWrapper>
    );
}

export default VirtualSolveInClass;
